import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {serviceTypesService} from "../../services/serviceTypes.service";

const initialState = {
    serviceTypes: [],
    status: '',
}

const getAll = createAsyncThunk('serviceTypesSlice/getAll',
    async () => {
        try {
            const {data} = await serviceTypesService.getAll();

            return data.results;
        } catch (error) {
            throw error;
        }
    });

const serviceTypesSlice = createSlice({
    name: 'serviceTypesSlice',
    initialState,
    reducers: {

    },
    extraReducers: builder => builder
        .addCase(getAll.fulfilled, (state, action) => {
            state.serviceTypes = action.payload;

            state.status = 'success';
        })
        .addCase(getAll.pending, (state, action) => {
            state.status = 'loading';
        })
});

const {actions, reducer: serviceTypesReducer} = serviceTypesSlice;

const serviceTypesActions = {
    ...actions,
    getAll,
}

export {
    serviceTypesActions,
    serviceTypesReducer,
}
